<mat-icon [class]="iconClasses()">{{ glyph() }}</mat-icon>
